import { ReactNode } from "react";

import { BoxProps } from "@/components/layout/flexbox";
import { Subtext } from "@/components/pieces/form/Subtext";

interface SmallCapsProps extends BoxProps {
  children: ReactNode;
  style?: React.CSSProperties;
}

export function SmallCaps(props: SmallCapsProps) {
  return (
    <Subtext {...props} style={{ textTransform: "uppercase", ...props.style }}>
      {props.children}
    </Subtext>
  );
}
